module.exports = __webpack_public_path__ + "img/45.148db841.png";